import React from 'react'
import PropTypes from 'prop-types'
import { Box, Paper, Typography } from '@material-ui/core'

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'

import useStyles from './styles'

const ReviewItemList = ({ title, items }) => {
  const classes = useStyles()

  return (
    <Box>
      <Typography variant="h6" color="textSecondary" gutterBottom>
        {title}
      </Typography>
      <Paper variant="outlined">
        <Table size="small" emptyMessage="Nenhum registro encontrado.">
          <TableHead>
            <TableRow>
              <TableCell width="20%">Item</TableCell>
              <TableCell width="80%">Descrição</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items?.map((item, index) => (
              <TableRow key={item?.position ?? index}>
                <TableCell>{item?.position}</TableCell>
                <TableCell className={classes.description}>
                  {item?.description}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  )
}

ReviewItemList.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.object),
}

export default ReviewItemList
